
import useGet from '../api/useGet';
import { createErrorStatus, ResponseStatus } from '@servicestack/client';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AuthenticateResponse, Authenticate } from '@/api/dtos';
import { useContext, useMemo } from 'react';

const request = () => {
    return new Authenticate();
};

const getData = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => response?.data;
const getError = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useAuthenticatedUser = (configuration: SWRConfiguration) => {
    return useGet(request, { getData, getError}, configuration);
};

export default useAuthenticatedUser;